/** @format */

import React, { useContext } from 'react'
import styled from 'styled-components'
import { CountContext } from './index'
import { Button, Card, Icon, Message, Tooltip } from '@king-design/react'
import { Tip } from '@king-design/react'
import { getStatus } from '../../Trigger/container'
import { applyAudit } from 'src/api/ApiEventOpsTrigger'
import SceneDesigner from './SceneGraph'

const ViewScene: React.FC<{ className?: string }> = ({ className }) => {
  const { setEditable, sceneInfo } = useContext(CountContext)

  // 审批
  const onApplyAudit = async (Status: -2 | -1 | 2) => {
    const result = await applyAudit({
      Module: 'scene',
      TargetID: sceneInfo.ApprovingID,
      Status
    })
    if (result) {
      if (Status === -2) {
        Message.success('审批撤回成功')
      } else if (Status === -1) {
        Message.success('审批驳回成功')
      } else if (Status === 2) {
        Message.success('审批通过成功')
      }
      window.location.reload()
    }
  }

  return (
    <div className={className}>
      {sceneInfo?.Approving && sceneInfo?.ApprovingID ? (
        <Tip type="warning" showIcon>
          <div>存在审批中的版本，暂不允许进行编辑操作。如确实需要，请先撤回审批。</div>
        </Tip>
      ) : null}

      {sceneInfo ? (
        <Card
          type="border"
          slotTitle={
            <div className="header">
              <div className="ksc-space">
                <span>{sceneInfo?.Name}</span>
                {getStatus(sceneInfo?.Status)}
              </div>
              {!sceneInfo?.Approving ? (
                <Tooltip disabled={sceneInfo?.IsPublic !== 1} content="系统场景不允许编辑">
                  <Button
                    type="link"
                    size="small"
                    disabled={sceneInfo?.IsPublic === 1}
                    onClick={() => {
                      setEditable(true)
                    }}
                  >
                    <Icon className="k-icon-edit" />
                    编辑
                  </Button>
                </Tooltip>
              ) : (
                <div className="ksc-space">
                  <Button
                    onClick={() => {
                      onApplyAudit(-1)
                    }}
                  >
                    驳回
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      onApplyAudit(2)
                    }}
                  >
                    通过
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <div className="content">
            <SceneDesigner />
          </div>
        </Card>
      ) : null}
    </div>
  )
}

export default styled(ViewScene)`
  .k-tip {
    margin-bottom: 8px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`
